import { apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class UIAPI {

    constructor() {
        this.baseUrl = new URL("ui/", apiFilesBaseURL);
    }

    getFooter() {
        return API.authenticatedRequest({
            url: new URL("footer/", this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
